<template>
      <video   controls controlslist="nodownload" οncοntextmenu="return false">
        <source src="https://www.shine-optics.com/video/ows/yoga.mp4"  type="video/mp4">
      </video> 
</template>